import { ApiError } from '~/lib/api-client';

/** Who called `send()`: the composer (its text comes back on failure) or the transcript's Continue button (no text). */
export type SendCaller = 'composer' | 'continue';

type CapacityLimit = 'deployment' | 'user';

// The server's 429 states only the situation; the next step depends on whether
// this caller put the person's text back. The per-person situation ends in its
// own timing ("until one of them finishes"), which is what "then" refers to.
const NEXT_STEP: Record<SendCaller, Record<CapacityLimit, string>> = {
  composer: {
    deployment: 'Your message is still in the box. Send it again in a few minutes.',
    user: 'Your message is still in the box. Send it again then.',
  },
  continue: {
    deployment: 'Try Continue again in a few minutes.',
    user: 'Try Continue again then.',
  },
};

const FALLBACK: Record<SendCaller, string> = {
  composer: 'Could not send the message',
  continue: 'Could not continue the build',
};

/** The toast text for a failed `send()`, true for the caller that made it. */
export function sendFailureMessage(err: unknown, caller: SendCaller): string {
  const message = (err as Error | undefined)?.message || FALLBACK[caller];
  const limit = err instanceof ApiError && err.status === 429 ? (err.body as { limit?: unknown } | undefined)?.limit : undefined;
  if (limit !== 'deployment' && limit !== 'user') return message;
  return `${message} ${NEXT_STEP[caller][limit]}`;
}
